import React from "react";
import Select from "react-select";

type Props = {
	value: string,
	updateConfig: Function
}

const PaidType = (props: Props) => {
	const metrics = [
		{label: "All", value: ""},
		{label: "Paid", value: "paid"},
		{label: "Free", value: "free"},
	];
	
	return (
		<div className="form-group">
			<label htmlFor="metricType">Story type:</label>
			<Select
				id="metricType"
				className="basic-single"
				classNamePrefix="so-select-metric-type"
				value={props.value ? metrics.find(item => item.value === props.value) : {label: "All", value: ""}}
				options={metrics}
				onChange={e => props.updateConfig(['paid_type'], [e!.value])}
				menuPortalTarget={document.body}
				styles={{menuPortal: base => ({...base, zIndex: 9999})}}
			/>
		</div>
	);
};

export default PaidType;
